import {SVG_ICON_NAMES} from 'common/components/svg-icon';

export function getIconSets() {
  const allIcons = {
    name: `All Icons (alphabetized)`,
    open: true,
    icons: SVG_ICON_NAMES,
  };
  const brandIcons = {
    name: `Brand Icons`,
    icons: SVG_ICON_NAMES.filter((icon) => icon.startsWith(`brand-`)),
  };
  const navigationIcons = {
    name: `Navigation Icons`,
    icons: [`search`, `help-center`, `community`, `idea`],
  };
  const notificationIcons = {
    name: `Notification Icons`,
    icons: [`email`, `inapp`, `push`, `sent`, `sms`, `webhook`],
  };
  const directionalIcons = {
    name: `Directional Icons`,
    icons: [
      `push-right`,
      `push-left`,
      `triangle-down`,
      `triangle-up`,
      `caret-up`,
      `caret-down`,
      `caret-left`,
      `caret-right`,
      `arrow-up`,
      `arrow-down`,
      `arrow-left`,
      `arrow-over-right`,
      `arrow-right`,
      `arrow-return`,
      `undo`,
      `redo`,
      `circle-increase`,
      `circle-decrease`,
    ],
  };
  const circleControlIcons = {
    name: `Circle Control Icons`,
    icons: [`circle-increase`, `circle-decrease`, `circle-checkmark`, `circle-clear`, `circle-drop`],
  };
  const queryHeaderIcons = {
    name: `Query Header Icons`,
    icons: [
      `save`,
      `open`,
      `sampling`,
      `alert-normal`,
      `alert-active`,
      `export`,
      `export-csv`,
      `export-png`,
      `export-pdf`,
      `undo`,
      `refresh`,
    ],
  };
  const queryControlIcons = {
    name: `Query Control Icons`,
    icons: [
      `edit`,
      `compose`,
      `duplicate`,
      `filter`,
      `segment`,
      `calendar`,
      `trashcan`,
      `dataset`,
      `tag`,
      `event`,
      `profile`,
      `event-attribute`,
      `group-attribute`,
      `profile-attribute`,
      `custom-event-beta`,
      `custom-events`,
      `custom`,
      `type-custom-number`,
      `type-custom-boolean`,
      `type-custom-list`,
      `type-custom-date`,
      `type-custom-text`,
      `type-number`,
      `type-boolean`,
      `type-list`,
      `type-date`,
      `type-text`,
      `type-object`,
    ],
  };
  const chartControlIcons = {
    name: `Chart Control Icons`,
    icons: [
      `bar`,
      `bar-stacked`,
      `bar-graph`,
      `conversion-first-step`,
      `conversion-prev-step`,
      `line`,
      `stacked-line`,
      `pie`,
      `table`,
      `single-metric`,
      `funnel-steps`,
      `top-paths`,
      `analysis`,
      `analysis-cumulative`,
      `analysis-linear`,
      `analysis-logarithmic`,
      `analysis-rolling`,
      `value-relative`,
      `value-absolute`,
      `sort-alpha-asc`,
      `sort-alpha-desc`,
      `sort-value-asc`,
      `sort-value-desc`,
      `time-first-step`,
      `time-prev-step`,
    ],
  };

  const groups = [
    brandIcons,
    navigationIcons,
    notificationIcons,
    directionalIcons,
    circleControlIcons,
    queryHeaderIcons,
    queryControlIcons,
    chartControlIcons,
  ];
  let uncategorizedIconsList = SVG_ICON_NAMES;
  for (const group of groups) {
    uncategorizedIconsList = uncategorizedIconsList.filter((icon) => group.icons.indexOf(icon) === -1);
  }

  const uncategorizedIcons = {
    name: `Uncategorized Icons`,
    icons: uncategorizedIconsList,
  };

  return [allIcons].concat(groups).concat([uncategorizedIcons]);
}
